const ICONS = {
    ACCOUNT: 'CircleUser',
    ADD: 'Plus',
    ADD_ALL: 'ListPlus',
    ADD_CONTRACT_ACCESS: 'HousePlus',
    ADD_DOWNLOAD_CODES: 'ClipboardList',
    ADD_ENVELOPES: 'MailPlus',
    ALERTS: 'BellRing',
    ALERT_MAIL: 'AtSign',
    AMOUNT: 'Banknote',
    API: 'Cloud', // Pas d’icône API dédiée
    ARROW_FORWARD: 'ArrowRight',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_LEFT: 'ArrowLeft',
    AUTO: 'Check',
    AUTO_REFRESH: 'RefreshCw',
    BLOCK: 'Ban',
    BURGER: 'PanelLeftOpen',
    CALENDAR: 'Calendar',
    CALENDAR_PLUS: 'CalendarPlus',
    CANCEL: 'CircleX',
    CHEVRON_LEFT: 'ChevronLeft',
    CHEVRON_DOWN: 'ChevronDown',
    CIRCLE: 'Circle',
    CHEVRON_UP: 'ChevronUp',
    CLOCK: 'Clock',
    CLOSE: 'X',
    COLUMNS: 'Columns3',
    CONNECTION: 'SlidersVertical',
    CONTENT_COPY: 'Copy',
    CONTACT_MAIL: 'Mail',
    CONTACT_PHONE: 'Phone',
    CONTACTLESS: 'Nfc',
    CONTRACT_ACCESS_ADD: 'Users',
    COPIED: 'CheckCheck',
    CREDIT_CARD: 'CreditCard',
    CUSTOMIZATION: 'Palette',
    DATA_USAGE: 'BarChart3',
    DASHBOARD: 'LayoutDashboard',
    DELETE: 'Trash',
    DEFAULT_PLAN: 'ClipboardCheck',
    DESELECT: 'SquareDashedMousePointer',
    DOCUMENTATION: 'FileText',
    DOMAIN: 'Server',
    DOWNLOAD: 'Share',
    DRAG: 'GripVertical',
    EDIT: 'Pencil',
    ELLIPSIS: 'Ellipsis',
    EMAIL: 'Mail',
    EMERGENCY_REMOTE_COLLECTION: 'ArrowLeftRight',
    ENVELOPES: 'FileUp',
    ERROR: 'CircleAlert',
    EURO: 'Euro',
    EVENT: 'CalendarDays',
    FILE_COPY: 'Files',
    FILTER: 'Funnel',
    FOLDER: 'Folder',
    FULLSCREEN_ENTER: 'Maximize',
    FULLSCREEN_EXIT: 'Minimize',
    GAVEL: 'Gavel',
    GPRS: 'CardSim',
    GPRS_SETTINGS: 'Settings',
    HELP: 'MessageCircleQuestionMark',
    HOME: 'House',
    INFO: 'Info',
    IN_STOCK: 'Warehouse',
    LESS_INFO: 'ChevronsDownUp',
    LINK: 'Link2',
    LINK_OFF: 'Link2Off',
    LOCATION: 'MapPinned',
    LOGOUT: 'Power',
    MAIL: 'Mail',
    MAP: 'MapPinned',
    MENU: 'Menu',
    MERCHANT_CONTRACT: 'Banknote',
    MERCHANT_CONTRACTS: 'Banknote',
    MESSAGE_SQUARE_MORE: 'MessageSquareMore',
    MIGRATE: 'ClockArrowDown',
    MORE: 'EllipsisVertical',
    MORE_INFO: 'ChevronRight',
    NEW_RELEASES: 'BadgeAlert',
    NEXT: 'SkipForward',
    NO_LOCATION: 'MapPinOff',
    OK: 'Check',
    ORGANIZATION: 'Building2',
    ORGANIZATIONS: 'Network',
    PANEL_LEFT: 'PanelLeftClose',
    PHONE: 'Phone',
    PHONE_IN_TALK: 'PhoneCall',
    PHONELINK_SETUP: 'Smartphone',
    PHOTO: 'Image',
    PLAN: 'Tag',
    PLANS: 'Tags',
    POS_TERMINAL_ACTIVATE: 'Check',
    POS_TERMINAL_CONTRACTS: 'ReceiptText',
    POS_TERMINAL_EVENT_LOGS: 'Link2',
    POS_TERMINAL_REMITTANCE: 'Landmark',
    POS_TERMINAL_TRANSACTIONS: 'Receipt',
    POS_TERMINAL_SUSPEND: 'X',
    POS_TERMINAL_TEMPORARY_ACTIVATE: 'AlarmClockCheck',
    POS_TERMINAL_TERMINATE: 'Ban',
    POS_TERMINAL_SCHEDULED_TERMINATE: 'AlarmClockOff',
    POS_TERMINAL: 'Smartphone',
    POS_TERMINAL_BLOCK: 'Lock',
    POS_TERMINAL_UNBLOCK: 'LockOpen',
    POS_TERMINALS: 'Smartphone',
    PREVIEW: 'Eye',
    PREVIOUS: 'SkipBack',
    PUSH_PAYMENTS: 'BadgeCheck',
    PUBLISH: 'CloudUpload',
    QR_CODE: 'QrCode',
    REDIRECT: 'SquareArrowOutUpRight',
    READ_MORE: 'RectangleEllipsis',
    REFRESH: 'RefreshCw',
    REMOTE_COLLECTION: 'Landmark',
    REMOVE: 'Minus',
    REMOVE_ALL: 'Undo',
    RESET: 'SearchX',
    RETRY_LOADING: 'Hourglass',
    SAVE: 'Save',
    SEARCH: 'Search',
    SECURITY: 'LockKeyhole',
    SETTINGS: 'Settings',
    SHOPPING_CART: 'ShoppingCart',
    SIM_CARD: 'CardSim',
    SIM_CARDS_SETTINGS: 'Settings',
    SIM_CARDS_SUSPEND: 'CirclePause',
    SIM_CARDS_REACTIVATE: 'Redo',
    SIM_CARDS_REASSIGN: 'UserRound',
    SIM_CARDS_OFFER: 'Signal',
    SIM_CARDS_OFFER_PENDING: 'RefreshCcw',
    SUBSCRIPTION: 'BriefcaseBusiness',
    SUBSCRIPTION_ACTIVATE: 'Check',
    SUBSCRIPTION_TERMINATE: 'CircleMinus',
    SUBSCRIPTION_SCHEDULED_TERMINATE: 'AlarmClockMinus',
    SUBSCRIPTIONS: 'BriefcaseBusiness',
    SWAP: 'ArrowUpDown',
    TAB: 'SquareDashedMousePointer',
    TERMINATE_CIRCLE: 'CircleX',
    TIMELINE: 'Activity', // Choix sémantique
    UPLOAD: 'FileDown',
    UPLOAD_LOGO: 'Upload',
    USER: 'UserRound',
    USER_MANAGE_ACCOUNT: 'UserRoundCog',
    USER_ACTIVATE: 'UserRound',
    USER_ADD: 'UserRoundPlus',
    USER_DEACTIVATE: 'UserRoundMinus',
    USER_GUIDE: 'BookOpenText',
    USER_PASS: 'LockKeyholeOpen',
    USER_SETTINGS: 'ShieldUser',
    USER_CONNECT_AS: 'UsersRound',
    USERS: 'UserRoundCog',
    VALIDATE: 'Check',
    VALIDATE_CIRCLE: 'CircleCheck',
    VISIBILITY: 'Eye',
    WARNING: 'TriangleAlert',
    ETHERNET: 'Network',
    WIFI: 'Wifi',
    PORT: 'Usb',
    PPP: 'ChevronsLeftRightEllipsis',
    UNKNOWN: 'CircleHelp',
    QUESTION: 'CircleHelp',
    HISTORY: 'History',
    DETAILS: 'Eye',
    MONETIZATION: 'Coins',
    SEND: 'Send',

    // Maintenance
    MAINTENANCE: 'Wrench'
};

export default ICONS;